/**
 * `core/scrollState.js`
 * - スクロール状態を管理
 * - 上下スクロールの方向を判定し、body クラスを変更
 *
 * 使用方法:
 * - import {initScrollState} from "core/scrollState.js";
 */

export function initScrollState() {
  observeScrollY();
  syncFixedElement();
}

function observeScrollY() {
  const body = document.body;
  const point = 300;
  let lastScrollY = window.scrollY;
  // let ticking = false;

  const updateScrollState = () => {
    const scrollY = window.scrollY;

    // スクロール方向の判定
    if (scrollY > lastScrollY) {
      body.classList.add("is-scroll-down");
      body.classList.remove("is-scroll-up");
    } else {
      body.classList.add("is-scroll-up");
      body.classList.remove("is-scroll-down");
    }

    // スクロール量の判定
    if (scrollY > point) {
      body.classList.add("is-scrolled");
    } else {
      body.classList.remove("is-scrolled");
    }

    lastScrollY = scrollY;
    // ticking = false;
  }

/*
  // 処理を軽くする場合は実装（ただし、クラス付与にラグが生じるのでアニメーションと連動させる場合はチラつくので注意）
  const onScroll = () => {
    if (!ticking) {
      requestAnimationFrame(updateScrollState);
      ticking = true;
    }
  };
  window.addEventListener("scroll", onScroll);
*/

  window.addEventListener("scroll", updateScrollState);
}


function syncFixedElement(selector = '.header') {
  const fixedElements = document.querySelectorAll(selector);

  if (!fixedElements.length) return;

  // スクロールイベント監視
  const syncFixedElements = () => {
    const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;

    // 横スクロールを `transform` で同期
    fixedElements.forEach(el => {

      el.style.transform = `translateX(-${scrollLeft}px)`;
    });
  };

  // 初回適用
  syncFixedElements();

  // スクロール時に同期
  window.addEventListener("scroll", syncFixedElements, { passive: true });

  // ウィンドウリサイズ時にリセット
  window.addEventListener("resize", () => {
    syncFixedElements();
  });
}